import { toString } from 'lodash';

import { IOcrAccountOrderDto } from '@/dtos';
import { OcrAccountOrderOption } from '@/modules/UseMyMoney/UseMyMoney.types';
import { formatOcrAccountOrder } from '@/modules/UseMyMoney/utils';

export const getAccountOrdersArraysWithUniqServices = (accountOrdersArrays?: IOcrAccountOrderDto[][]): OcrAccountOrderOption[][] | undefined => {
  if (!accountOrdersArrays?.length) {
    return;
  }

  const sortedAccountOrdersArrays = accountOrdersArrays
    ?.map((accountOrders) => accountOrders?.sort((prev, next) => ((prev?.order || 0) > (next?.order || 0) ? 1 : -1)));

  const accountOrdersArraysWithUniqServices = sortedAccountOrdersArrays?.map((accountOrders, index) => {
    const seenServiceIds = new Set<string>();

    return accountOrders.map((accountOrder) => {
      const formatted = formatOcrAccountOrder(accountOrder, index);
      const uniqueServices = (formatted.services || []).filter((service) => {
        if (seenServiceIds.has(service.id || '')) return false;
        seenServiceIds.add(service.id || '');
        return true;
      });

      return { ...formatted, index: toString(index), services: uniqueServices };
    });
  });

  return accountOrdersArraysWithUniqServices;
};
